export default "__VITE_ASSET__CnITXm$7__";